import { Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
import { PromoCodeMessage } from 'routes/components/PromoCodeMessage/PromoCodeMessage'
import { OnboardingReferralBanner as SuiOnboardingReferralBanner } from './components/OnboardingReferralBanner/OnboardingReferralBanner'

export const Root = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(0.5),
  [theme.breakpoints.up('mobile')]: {
    gap: theme.spacing(1),
  },
}))

export const AppliedPromoCodeMessage = styled(PromoCodeMessage)(({ theme }) => ({
  [theme.breakpoints.up('mobile')]: {
    width: '800px',
  },
}))

export const OnboardingReferralBanner = styled(SuiOnboardingReferralBanner)(({ theme }) => ({
  [theme.breakpoints.up('mobile')]: {
    width: '800px',
  },
}))
